import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiClient } from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULT = {
    business_name: "Jassi Wood Works",
    tagline: "Bespoke woodcraft, built to last generations",
    phone: "+91 98765 43210",
    whatsapp: "919876543210",
    email: "hello@jassiwoodworks.com",
    address: "Plot 12, Industrial Area, Phase 1, Mohali, Punjab 160055, India",
    maps_query: "Industrial+Area+Phase+1+Mohali+Punjab",
    logo_url: "",
    instagram: "https://instagram.com/jassiwoodworks",
    facebook: "https://facebook.com/jassiwoodworks",
    youtube: "https://youtube.com/@jassiwoodworks",
    instagram_username: "jassiwoodworks",
    instagram_feed: [],
    seo_title: "Jassi Wood Works — Bespoke Woodcraft",
    seo_description: "",
    seo_keywords: "",
    og_image: "",
};

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(DEFAULT);

    const refresh = useCallback(async () => {
        try {
            const { data } = await apiClient.get("/settings");
            setSettings({ ...DEFAULT, ...data });
            // Update SEO meta tags
            if (data.seo_title) document.title = data.seo_title;
            const desc = document.querySelector('meta[name="description"]');
            if (desc && data.seo_description) desc.setAttribute("content", data.seo_description);
            const keywords = document.querySelector('meta[name="keywords"]');
            if (keywords && data.seo_keywords) keywords.setAttribute("content", data.seo_keywords);
        } catch {
            // keep defaults
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return (
        <SettingsContext.Provider value={{ settings, refresh, setSettings }}>
            {children}
        </SettingsContext.Provider>
    );
}

export const useSettings = () => useContext(SettingsContext);
